import { motion } from "framer-motion";
import { Medal, Award, Building2 } from "lucide-react";
import { CertForm } from "@/components/landing/CertForm";

const TRACKS = [
  { icon: Medal, name: "Frontline COC", desc: "Every new community manager runs the same certified curriculum — fair housing, walks, collections, resident experience." },
  { icon: Award, name: "Regional Advanced", desc: "Regional managers earn advanced certification in audits, corrective action, and portfolio intelligence." },
  { icon: Building2, name: "Property Score", desc: "Certified teams produce scored properties — an operational grade owners can benchmark and buyers can trust." },
];

export const CertWaitlist = () => (
  <section id="certification" className="relative py-24 sm:py-32 border-t border-slate-200 bg-[#E2EDF8]" data-testid="cert-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="lg:col-span-6"
      >
        <p className="eyebrow mb-4 flex items-center gap-3">
          <span className="inline-block h-px w-10 bg-cadmium" /> The Standard
        </p>
        <h2 className="font-cabinet text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-slate-900">
          Don't just run software.{" "}
          <span className="font-editorial italic font-normal text-sky-600">Run the standard.</span>
        </h2>
        <p className="mt-5 text-base text-muted-foreground leading-relaxed max-w-xl">
          Community Operations Certification (COC) turns OPERA360 from a tool into a credential. Companies put every
          new manager through the curriculum, regional managers earn advanced certification, and certified properties
          carry an operational score that means something.
        </p>
        <div className="mt-8 space-y-5">
          {TRACKS.map((t) => (
            <div key={t.name} className="flex items-start gap-4">
              <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-sm border border-cadmium/40 bg-cadmium/10">
                <t.icon size={18} className="text-sky-600" />
              </span>
              <div>
                <p className="text-sm font-semibold text-slate-900">{t.name}</p>
                <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{t.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <a
          href="/certification"
          data-testid="cert-explore-link"
          className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-sky-600 hover:text-cadmium-hover transition-colors"
        >
          Explore the full curriculum, sample quiz & cohort pricing →
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="lg:col-span-6"
      >
        <CertForm />
      </motion.div>
    </div>
  </section>
);
